import { cfg } from '../../config';
import dotenv from 'dotenv';

dotenv.config();

export async function pushNickname(nickname, userId) {
  try {
    const response = await fetch(`${process.env.HOST}/${cfg.API.routes.user}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userId: userId,
        nickname: nickname,
      }),
    });
    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    return { success: false, data: error };
  }
}
